var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[(!_vm.isLink)?_c('h1',[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(_vm.isLink)?_c('h1',[_c('router-link',{attrs:{"to":{name: 'TemplateBuilder', query: _vm.backQuery}}},[_c('font-awesome-icon',{attrs:{"icon":['far', 'chevron-left'],"size":"lg"}}),_vm._v(" "+_vm._s(_vm.title)+" ")],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }